import React from 'react'
import MosaicInput from './MosaicInput'
import PropTypes from 'prop-types'

function Alerts ({ state, onChange }) {
  return (
    <div>
      <MosaicInput
        inputTitle='Not Found Alert Title'
        id='alert-title'
        className='form-control'
        placeholder='Handle not found'
        value={state.alertImageNotFoundTitle}
        onChange={onChange('alertImageNotFoundTitle')}
      />
      <MosaicInput
        inputTitle='Not Found Alert Text'
        id='alert-text'
        className='form-control'
        placeholder='No picture matching this handle was found.'
        value={state.alertImageNotFoundbody}
        onChange={onChange('alertImageNotFoundbody')}
      />
      <MosaicInput
        inputTitle='Find Me Button Text'
        id='find-me-button-text'
        className='form-control'
        placeholder='Find Me!'
        value={state.findMeButtonText}
        onChange={onChange('findMeButtonText')}
      />
    </div>
  )
}

Alerts.propTypes = {
  state: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired
}

export default Alerts



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-mosaic-deployment/components/Alerts.js